export default "__VITE_ASSET__WgYGTfwx__"